import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  header: {
    width: "96px",
    fontSize: "12px",
    textAlign: "center",
    overflowWrap: "anywhere",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "2px",
    paddingRight: "2px",
  },
  contentContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "40px",
    fontSize: "24px",
    marginBottom: theme.spacing(2),
    "& > *:first-child": {
      minHeight: "40px",
    },
    "& .material-icons": {
      fontSize: "40px",
    },
  },
  button: {
    color: theme.palette.primary.dark,
    backgroundColor: "white",
    width: "96px",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    borderRadius: "4px",
    padding: 0,
    border: "none",
    "& .material-icons": {
      fontSize: "40px",
    },
    "&:hover": {
      color: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main + "aa",
    },
    "& > *": {
      flexBasis: "50%",
    },
  },
  buttonWithText: {
    // Use default size:
    // fontSize: '1px'
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: "flex",
    overflowX: "auto",
    "& > li": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      whiteSpace: "normal",
      borderRight: `1px solid ${theme.palette.primary.light}`,
    },
    "& > li:last-child": {
      borderRight: "none",
    },
  },
}));

export const Bubble = ({ content, header, onClick, disabled }) => {
  const classes = useStyles();
  return (
    <li className={classes.toolbarContainer}>
      <button
        className={`${classes.button} ${classes.buttonWithText}`}
        aria-label={header}
        onClick={onClick}
        disabled={disabled}
      >
        <div className={classes.contentContainer}>{content}</div>
        <div className={classes.header}>{header}</div>
      </button>
    </li>
  );
};

export const BubbleList = ({ children }) => {
  const classes = useStyles();
  return <ul className={classes.list}>{children}</ul>;
};
